module.exports = __webpack_public_path__ + "img/222A0625.2db18c32.png";